import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, XCircle, Loader2, Clock } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function EmailVerify() {
  const [sp] = useSearchParams();
  const token = sp.get("token");
  const [status, setStatus] = useState("verifying"); // verifying | ok | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!token) { setStatus("error"); setMessage("Token em falta no link."); return; }
    axios.get(`${API}/api/signup/verify?token=${encodeURIComponent(token)}`)
      .then((r) => { setStatus("ok"); setMessage(r.data.message || "Email confirmado."); })
      .catch((err) => { setStatus("error"); setMessage(err.response?.data?.detail || err.message); });
  }, [token]);

  return (
    <div className="min-h-screen bg-[#0a0f1e] text-white flex items-center justify-center p-6">
      <div className="max-w-md w-full text-center">
        {status === "verifying" && (
          <>
            <Loader2 className="w-16 h-16 mx-auto text-[#f59e0b] animate-spin" />
            <h1 className="font-display text-2xl mt-4">A confirmar o seu email…</h1>
          </>
        )}
        {status === "ok" && (
          <>
            <CheckCircle2 className="w-16 h-16 mx-auto text-emerald-400" data-testid="verify-ok" />
            <h1 className="font-display text-2xl mt-4">Email confirmado</h1>
            <p className="text-slate-300 mt-2">{message}</p>
            <div className="mt-6 border border-amber-500/30 bg-amber-500/10 p-4 text-sm text-amber-100 flex items-start gap-2 text-left">
              <Clock className="w-4 h-4 mt-0.5" />
              <div>A DiTours está a analisar os seus dados. Receberá um email quando a conta for activada. Pode demorar 24-48h.</div>
            </div>
            <Link to="/login" className="inline-block mt-6 text-[#f59e0b] hover:underline">Ir para login</Link>
          </>
        )}
        {status === "error" && (
          <>
            <XCircle className="w-16 h-16 mx-auto text-red-400" data-testid="verify-error" />
            <h1 className="font-display text-2xl mt-4">Não foi possível confirmar</h1>
            <p className="text-slate-400 mt-2">{message}</p>
            <Link to="/signup" className="inline-block mt-6 text-[#f59e0b] hover:underline">Tentar de novo</Link>
          </>
        )}
      </div>
    </div>
  );
}
